import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { camps } from '../../../../../models/models.generated';
import { CampsEnumTranslationService } from '../../../../../services/camps-enum-translation.service';

@Component({
    selector: 'app-purchase-edit-session-summary-item',
    templateUrl: './purchase-edit-session-summary-item.component.html',
    styleUrls: [ './purchase-edit-session-summary-item.component.scss' ],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PurchaseEditSessionSummaryItemComponent {

    item = input.required<camps.ModifiedSessionInfo>();
    options = computed(() => [
        ...(this.item()?.selectedOptions ?? []).map(option => ({ ...option, isRemoved: false })),
        ...(this.item()?.removedOptions ?? []).map(option => ({ ...option, isRemoved: true }))
    ].sort((a, b) => a.name.localeCompare(b.name)));
    timeVariant = computed(() => this.translateService.timeVariant(this.item()?.timeVariant.type));

    private translateService = inject(CampsEnumTranslationService);
}
